import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminEmployeeCheckin() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin Employee Checkin page</h1>
                </div>
            </div>
        </>
    )
}
